import { useUserStore } from '@/stores/user'

import boxApi, { getFSToken } from './api'

export interface IFile {
  id: string
  key: string
  name: string
  isDir: boolean
  size: number
  dirname: string
  path: string
  ext?: string
  updateTime: number
}

export async function ls(params: {
  path: string
  domain: number
}): Promise<{ code: number; msg: string; files: IFile[] }> {
  const { path, domain } = params
  const { code, msg, infos } = await boxApi.get('/vol', {
    params: { path },
    noErrMsg: true,
    domain,
    headers: {
      Authorization: await getFSToken(domain),
    },
  })
  if (code === 0 && Array.isArray(infos) && infos.length > 0) {
    return {
      code,
      msg,
      files: infos.map(
        (info: {
          name: string
          isDir: boolean
          size: number
          createTime: { seconds: number }
          modTime: { seconds: number }
        }) => {
          const key = info.name
          const name = info.name
          const isDir = info.isDir
          const dirname = params.path
          const size = info.size
          const updateTime = info.modTime.seconds

          const id = btoa(encodeURIComponent(`${info.name}-${size}-${info.createTime.seconds}`))

          let ext: string | undefined = undefined
          if (isDir) {
            const fComponents = (name as string)?.split('.')?.reverse()
            if (fComponents?.length) {
              ext = fComponents[0].toLowerCase()
            }
          }

          return {
            id,
            key,
            name,
            isDir,
            size,
            updateTime,
            ext,
            dirname: dirname,
            path: isDir ? `${dirname}${name}/` : `${dirname}${name}`,
          }
        },
      ),
    }
  }
  return { code, msg, files: [] }
}

export async function mv(params: { path: string; target: string; domain: number }): Promise<void> {
  const { path, target, domain } = params
  const token = await getFSToken(domain)
  return new Promise<void>((resolve, reject) => {
    boxApi
      .patch(
        '/vol',
        { path, target },
        {
          headers: {
            Authorization: token,
          },
          params: { path, target },
          noErrMsg: true,
          domain,
        },
      )
      .then(({ code }) => {
        if (code === 0) {
          resolve()
        } else {
          reject()
        }
      })
      .catch((e) => {
        reject(e)
      })
  })
}

export async function download(params: { path: string; domain: number }): Promise<void> {
  const { path, domain } = params
  const a = document.createElement('a')
  a.download = path.split('/').reverse()[0]
  const token = await getFSToken(domain)
  const baseURL = useUserStore.getState().domainCurrentServiceMap[domain]
  a.href = `${baseURL}/vol?path=${encodeURIComponent(path)}&Authorization=${encodeURIComponent(
    token,
  )}`
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export function validFileName(filename: string) {
  if (filename == '.' || filename == '..') return false
  const filenameReg = /^[\u4E00-\u9FA5A-Za-z0-9_\-\\.]+$/g
  return filenameReg.test(filename)
}
